import React from 'react';
import DragHotspot from 'components/DragHotspot';
import styles from './styles.module.scss';

export const CarouselItemDragHotSpot: React.FC<{ canDrop: boolean }> = ({ canDrop }) => {
  if (!canDrop) {
    return null;
  }

  return (
    <div className={styles.dragHotSpot}>
      <DragHotspot />
    </div>
  );
};
